import { DatePipe } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  signal,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FollowUpTimelineComponent } from '@app/modules/follow-ups/components/follow-up-timeline/follow-up-timeline.component';
import {
  FollowUp,
  FollowUpsUser,
} from '@app/modules/follow-ups/follow-ups.types';
import { GetFollowUpAction } from '@app/modules/follow-ups/store/follow-ups.actions';
import { FollowUpsState } from '@app/modules/follow-ups/store/follow-ups.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DisplayNamePipe } from '@shared/pipes/display-name.pipe';
import { switchMap } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'app-follow-up-details',
  imports: [
    TranslatePipe,
    FollowUpTimelineComponent,
    DatePipe,
    DisplayNamePipe,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './follow-up-details.component.html',
})
export class FollowUpDetailsComponent implements OnInit {
  private store = inject(Store);
  private modalRef = inject(NgbActiveModal);

  @Input() followUpId: string;

  followUp = signal<FollowUp>(null);
  protected users: FollowUpsUser[] = [];

  ngOnInit() {
    this.users = this.store.selectSnapshot(FollowUpsState.getFollowUpsUsers);
    this.store
      .dispatch(new GetFollowUpAction(this.followUpId))
      .pipe(
        switchMap(() => this.store.select(FollowUpsState.getFollowUpById)),
        map((getById) => getById(this.followUpId)),
        first()
      )
      .subscribe((followUp) => {
        this.followUp.set(followUp);
      });
  }

  close() {
    this.modalRef.close();
  }
}
